import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { bootMobile } from "@/mobile/bootstrap";

// Mobile (Capacitor) layer: status bar, hardware back button, push
// notifications, biometric storage. No-op on web. Receives a pre-built
// axios instance so push-token registration hits the SAME backend the
// rest of the app uses (process.env.REACT_APP_BACKEND_URL/api).
const mobileApi = axios.create({
  baseURL: (process.env.REACT_APP_BACKEND_URL || '') + '/api',
});
bootMobile(mobileApi).catch((err) => console.warn('bootMobile failed', err));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
